var chunkMapping = {
	"95": [
		137,
		828,
		848,
		2391,
		3580,
		4064,
		5620,
		5894,
		6744,
		9283,
		9518,
		9684
	],
	"381": [
		7381
	],
	"631": [
		4963
	],
	"675": [
		7693
	]
};
var idToExternalAndNameMapping = {
	"137": [
		"default",
		"./register",
		7883
	],
	"828": [
		"default",
		"./UnboxingPageIntroduction",
		616
	],
	"848": [
		"default",
		"./Request",
		1441
	],
	"2391": [
		"default",
		"./UnboxingPageHeader",
		616
	],
	"3580": [
		"default",
		"./UnboxingPageBody",
		616
	],
	"4064": [
		"default",
		"./UnboxingPageIntegrationBanner",
		616
	],
	"4963": [
		"default",
		"./History",
		1441
	],
	"5620": [
		"default",
		"./UnboxingPageRow",
		616
	],
	"5894": [
		"default",
		"./UnboxingPageCol",
		616
	],
	"6744": [
		"default",
		"./UnboxingPage",
		616
	],
	"7381": [
		"default",
		"./cWrapper",
		1441
	],
	"7693": [
		"default",
		"./Selectors",
		1441
	],
	"9283": [
		"default",
		"./unboxing-page",
		616
	],
	"9518": [
		"default",
		"./UnboxingPageDocumentation",
		616
	],
	"9684": [
		"default",
		"./UnboxingPageCrossSelling",
		616
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}